// mobile-nav.js
import siteCommon from 'site/site-common'
import gsap, { Power3 } from 'imports/gsap'

let mobileNav = {
    init:function () {
        const self = this;
        $('#nav-icon').off('click.mobileNav').on('click.mobileNav', self.doHamburerToggle);

        // minimal: add caret buttons, hide subnav via CSS, and bind a single toggle
        const container = $('#mobile-nav-container');

        container.find('.header-nav .nav-item.has-children').each(function(){
            const $item = $(this);
            if ($item.children('.nav-caret').length === 0) {
                const caret = $('<button type="button" class="nav-caret" aria-expanded="false" aria-label="Toggle submenu"></button>');
                const $link = $item.children('a').first();
                if ($link.length) { $link.after(caret); } else { $item.prepend(caret); }
            }
        });

        container.off('click.navToggle', '.header-nav .nav-item.has-children > .nav-caret, .header-nav .nav-item.has-children > a')
            .on('click.navToggle', '.header-nav .nav-item.has-children > .nav-caret, .header-nav .nav-item.has-children > a', function(e){
                if ($(this).is('a') && !$('#mobile-nav-container').hasClass('open')) return; // normal nav when closed
                e.preventDefault();
                const $item = $(this).closest('.nav-item.has-children');
                const isOpen = $item.hasClass('is-open');
                // close siblings at same level
                $item.siblings('.has-children.is-open').removeClass('is-open')
                    .children('.nav-caret').attr('aria-expanded','false');
                // toggle current
                $item.toggleClass('is-open', !isOpen)
                    .children('.nav-caret').attr('aria-expanded', (!isOpen).toString());
            });

        mobileNav.overlayHide();
    },

    doHamburerToggle:function(){
        const c = $('#mobile-nav-container');
        c.toggleClass('open');
        if (!c.hasClass('open')) {
            c.find('.header-nav .nav-item.has-children.is-open')
                .removeClass('is-open')
                .children('.nav-caret').attr('aria-expanded','false');
        }
    },

    overlayHide:function() {
        $('#mobile-nav-container').removeClass('open');
    },
    overlayShow:function() {
        $('#mobile-nav-container').addClass('open');
    }
}; //obj

export default mobileNav
